import { VISIBILITY_GROUP } from "../constants";
import pluralize from "pluralize";
import { capitalizeString, customNames } from "src/utils/helpers";

export const getVisibilityOptions = () => [
    { value: VISIBILITY_GROUP.EMPLOYEES, label: capitalizeString(pluralize(customNames.employees)) },
    { value: VISIBILITY_GROUP.CLIENTS, label: capitalizeString(pluralize(customNames.clients)) },
    { value: VISIBILITY_GROUP.EMPLOYEES_AND_CLIENTS, label: "All Users" }
];

export const getVisibilityLabel = (value) => {
    switch (value) {
        case VISIBILITY_GROUP.EMPLOYEES:
            return getVisibilityOptions()[0].label;
        case VISIBILITY_GROUP.CLIENTS:
            return getVisibilityOptions()[1].label;
        default:
            return "All Users";
    }
};
